import { useQueryClient } from 'react-query';

import { useConfig } from '@/common/contexts/ConfigContext';
import {
  MERCURE_MESSAGE_TYPE_MAINTENANCE,
  useMercureContext,
} from '@/common/contexts/MercureContext/MercureContext';
import useMercureMessageSubscriber from '@/common/contexts/MercureContext/useMercureMessageSubscriber';

const useMaintenanceSubscription = (queryKey) => {
  const { publicTopic } = useMercureContext();
  const { isEbat, isChrono, isMateriaux } = useConfig();

  const queryClient = useQueryClient();

  const handleSubscribe = (data) => {
    queryClient.setQueryData(queryKey, (previousData) => {
      const newData = { ...previousData };

      if (
        (isEbat && data.payload.EB) ||
        (isChrono && data.payload.EBC) ||
        (isMateriaux && data.payload.LM)
      ) {
        newData.enabled = true;
      } else {
        newData.enabled = false;
      }

      return newData;
    });
  };

  useMercureMessageSubscriber(
    publicTopic,
    MERCURE_MESSAGE_TYPE_MAINTENANCE,
    handleSubscribe,
  );
};

export default useMaintenanceSubscription;
